import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import Select from "react-select"; // Import react-select
import useCities from "@/features/city/hooks/useCities";
import { Input, Textarea } from "@material-tailwind/react";
import ClientTypeRadioGroup from "@/features/clientType/components/ClientTypeRadioGroup";
const defaultClient = {
    client_type: "",
    denomination: "",
    email: "",
    telephone: "",
    adresse: "",
    ville_id: 0,
    indic_actif: true,
};
const ClientForm = ({ initialData, onSubmit, onCancel }) => {
    const [formData, setFormData] = useState(initialData || defaultClient);
    const { cities } = useCities(undefined, undefined, true); // Hook pour récupérer les villes
    const [errors, setErrors] = useState({});
    // Convertir les villes en options pour react-select
    const cityOptions = cities.map((city) => ({
        value: city.id,
        label: city.label,
    }));
    const handleChange = (e) => {
        const { name, value, type } = e.target;
        const newValue = type === "checkbox" ? e.target.checked : value;
        setFormData((prev) => ({ ...prev, [name]: newValue }));
    };
    const handleChangeRadio = (e) => {
        const { name, value, type } = e.target;
        const newValue = type === "checkbox" ? e.target.checked : value;
        setFormData((prev) => ({ ...prev, [name]: newValue }));
    };
    const handleCityChange = (selectedOption) => {
        setFormData((prev) => ({ ...prev, ville_id: selectedOption?.value }));
    };
    const validateFields = () => {
        const newErrors = {};
        if (!formData?.denomination?.trim()) {
            if (formData?.client_type === "particulier") {
                newErrors.denomination = "Le champs nom & prénom est obligatoire.";
            }
            else {
                newErrors.denomination = "La dénomination est obligatoire.";
            }
        }
        else if (formData.denomination.length < 3) {
            newErrors.denomination = "Le champs doit contenir au moins 3 caractères.";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = () => {
        if (!validateFields()) {
            return;
        }
        if (formData) {
            onSubmit(formData);
        }
    };
    return (_jsxs("div", { className: "bg-white w-full", children: [_jsxs("div", { className: "flex flex-col md:flex-row justify-between items-center border-b p-4 bg-gray-100", children: [formData?.id &&
                        _jsx("h1", { className: "text-l font-bold", children: _jsxs("span", { className: "text-blue-900", children: [" Modification du client : ", formData.denomination] }) }), !formData?.id &&
                        _jsx("h1", { className: "text-l font-bold", children: _jsx("span", { className: "text-blue-900", children: "Ajouter un client" }) })] }), _jsxs("form", { className: "space-y-6 p-4", children: [_jsx("div", { className: "flex flex-col sm:flex-row items-start sm:items-center gap-4", children: _jsx(ClientTypeRadioGroup, { value: formData?.client_type ?? "", onChange: handleChangeRadio }) }), _jsxs("div", { className: "space-y-4", children: [_jsx(Input, { variant: "standard", label: formData?.client_type === "particulier" ? "Nom & Prénom" : "Dénomination", name: "denomination", value: formData?.denomination, type: "text", placeholder: formData?.client_type === "particulier" ? "Nom & Prénom" : "Dénomination", onChange: handleChange, className: "w-full", crossOrigin: "" }), errors.denomination &&
                                _jsx("p", { className: "text-sm text-red-500 mt-1", children: errors.denomination })] }), _jsx("div", { className: "space-y-4", children: _jsx(Input, { variant: "standard", label: "ICE", name: "ice", value: formData?.ice, type: "text", placeholder: "ICE", onChange: handleChange, className: "w-full", crossOrigin: "" }) }), _jsx("div", { children: _jsx(Input, { variant: "standard", label: "Email", name: "email", value: formData?.email, type: "text", placeholder: "Email", onChange: handleChange, className: "w-full", crossOrigin: "" }) }), _jsx("div", { children: _jsx(Input, { variant: "standard", label: "T\u00E9l\u00E9phone", name: "telephone", value: formData?.telephone, type: "text", placeholder: "T\u00E9l\u00E9phone", onChange: handleChange, className: "w-full", crossOrigin: "" }) }), _jsx("div", { children: _jsx(Textarea, { variant: "standard", label: "Adresse", name: "adresse", value: formData?.adresse, onChange: handleChange, className: "w-full" }) }), _jsx(Select, { options: cityOptions, name: "ville", value: cityOptions.find((option) => option.value === formData?.ville_id) || null, onChange: handleCityChange, placeholder: "Rechercher une ville...", isClearable: true, className: "rounded border" }), _jsxs("label", { className: "flex items-center gap-2", children: [_jsx("input", { type: "checkbox", name: "indic_actif", checked: formData?.indic_actif, onChange: handleChange, className: "w-4 h-4" }), "Actif"] }), _jsxs("div", { className: "flex flex-col sm:flex-row gap-4 justify-end p-2", children: [_jsx("button", { type: "button", onClick: onCancel, className: "bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600", children: "Annuler" }), _jsx("button", { type: "button", onClick: handleSubmit, className: "bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600", children: "Sauvegarder" })] })] })] }));
};
export default ClientForm;
